var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadpdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3V6C10 6.55228 10.4477 7 11 7H13",
    stroke: "#006CC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H11",
    stroke: "#006CC5",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H11",
    stroke: "#006CC5",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H11",
    stroke: "#006CC5",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6039 12H16.3927C16.6387 12 16.8399 12.2144 16.8399 12.4765V14.8588H17.551C17.949 14.8588 18.1503 15.3734 17.8685 15.6736L15.8158 17.8606C15.7323 17.9499 15.6188 18 15.5006 18C15.3823 18 15.2688 17.9499 15.1853 17.8606L13.1326 15.6736C12.8508 15.3734 13.0476 14.8588 13.4456 14.8588H14.1567V12.4765C14.1567 12.2144 14.3579 12 14.6039 12Z",
    fill: "#006CC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17H4C3.44772 17 3 16.5523 3 16V4C3 3.44772 3.44772 3 4 3H9.17157C9.43679 3 9.69114 3.10536 9.87868 3.29289L12.7071 6.12132C12.8946 6.30886 13 6.56321 13 6.82843V11H14V6.82843C14 6.29799 13.7893 5.78929 13.4142 5.41421L10.5858 2.58579C10.2107 2.21071 9.70201 2 9.17157 2H4C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H12V17Z",
    fill: "#006CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadpdf);
export default __webpack_public_path__ + "static/media/downloadpdf.777f147a76928338c52380aadbe43c02.svg";
export { ForwardRef as ReactComponent };